import React, { useEffect, useState } from 'react';
import Icon from '@/components/Icon';
import { ApiError, api } from '@/lib/api';

const EMPTY = {
  type: 'school',
  name: '',
  price: '',
  timeStart: '08:00',
  timeEnd: '18:30',
  archive: false,
};

export default function TariffEditModal({ mode, tariff, onClose, onSaved }) {
  const [data, setData] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (mode === 'edit' && tariff) {
      setData({
        type: tariff.type || 'school',
        name: tariff.name || '',
        price: tariff.price ?? '',
        timeStart: tariff.timeStart || '08:00',
        timeEnd: tariff.timeEnd || '18:30',
        archive: !!tariff.archive,
      });
    } else {
      setData(EMPTY);
    }
  }, [mode, tariff?.id]);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  const set = (k, v) => setData((d) => ({ ...d, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true); setError(null);
    try {
      const payload = {
        type: data.type,
        name: data.name.trim(),
        price: Number(data.price) || 0,
        timeStart: data.timeStart,
        timeEnd: data.timeEnd,
        archive: data.archive,
      };
      const res = mode === 'create'
        ? await api.post('/api/tariffs', payload)
        : await api.put(`/api/tariffs/${tariff.id}`, payload);
      onSaved?.(res.tariff);
      onClose();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Не удалось сохранить');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="sd-overlay" onClick={(e) => { if (e.target.classList.contains('sd-overlay')) onClose(); }}>
      <div className="sd-modal sd-modal--narrow" role="dialog" aria-modal="true">
        <div className="sd-edit__head">
          <h2>{mode === 'create' ? 'Новый тариф' : 'Редактирование тарифа'}</h2>
          <button className="sd-close" onClick={onClose}><Icon name="x" size={14} /></button>
        </div>

        <form onSubmit={submit} className="sd-edit__form" noValidate>
          <div className="sd-edit__body">
            <div className="sd-edit__field sd-edit__field--full">
              <label className="sd-edit__label">Тип *</label>
              <select className="sd-edit__select" value={data.type} onChange={(e) => set('type', e.target.value)}>
                <option value="school">Школа</option>
                <option value="kindergarten">Детский сад</option>
              </select>
            </div>

            <div className="sd-edit__field sd-edit__field--full">
              <label className="sd-edit__label">Название *</label>
              <input
                className="sd-edit__input"
                value={data.name}
                onChange={(e) => set('name', e.target.value)}
                placeholder="например, Школа (2025/2026)"
                required
                autoFocus
              />
            </div>

            <div className="sd-edit__field">
              <label className="sd-edit__label">Цена в месяц, ₽ *</label>
              <input
                className="sd-edit__input"
                type="number"
                min="0"
                step="0.01"
                value={data.price}
                onChange={(e) => set('price', e.target.value)}
                required
              />
            </div>
            <div className="sd-edit__field"></div>

            <div className="sd-edit__field">
              <label className="sd-edit__label">Время начала</label>
              <input
                className="sd-edit__input"
                type="time"
                value={data.timeStart}
                onChange={(e) => set('timeStart', e.target.value)}
              />
            </div>
            <div className="sd-edit__field">
              <label className="sd-edit__label">Время окончания</label>
              <input
                className="sd-edit__input"
                type="time"
                value={data.timeEnd}
                onChange={(e) => set('timeEnd', e.target.value)}
              />
            </div>

            <div className="sd-edit__field sd-edit__field--full">
              <label className="ref-checkbox">
                <input
                  type="checkbox"
                  checked={data.archive}
                  onChange={(e) => set('archive', e.target.checked)}
                />
                <span>В архиве (скрыт из выпадашек выбора)</span>
              </label>
            </div>
          </div>

          <div className="sd-edit__foot">
            {error && <div className="sd-edit__error">{error}</div>}
            <div className="sd-edit__foot-spacer" />
            <button type="button" className="btn btn--sm" onClick={onClose}>Отмена</button>
            <button type="submit" className="btn btn--primary btn--sm" disabled={saving}>
              {saving ? 'Сохраняем…' : (mode === 'create' ? 'Создать' : 'Сохранить')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
